"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIncompleteItems = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = require("react");
var types_1 = require("../../../../drill/types");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var addOrUpdateDrillConfigItem = function (drillConfigItems, newItem) {
    var found = drillConfigItems.findIndex(function (drillConfigItem) { return drillConfigItem.localIdentifier === newItem.localIdentifier; });
    if (found !== -1) {
        var incompleteItemsUpdated = tslib_1.__spread(drillConfigItems);
        incompleteItemsUpdated[found] = newItem;
        return incompleteItemsUpdated;
    }
    else {
        return tslib_1.__spread(drillConfigItems, [newItem]);
    }
};
/**
 * Hook for manipulation with incomplete IDrillConfigItem
 * @internal
 */
exports.useIncompleteItems = function (props) {
    var widgetDrills = props.widgetDrills;
    var _a = tslib_1.__read(react_1.useState([]), 2), incompleteItems = _a[0], updateIncompleteItems = _a[1];
    var prevWidgetDrills = sdk_ui_1.usePrevious(widgetDrills);
    react_1.useEffect(function () {
        //when widgetDrills changed remove all complete widget items
        if (!isEqual_1.default(widgetDrills, prevWidgetDrills)) {
            var incompleteItemsUpdated = incompleteItems.filter(function (incompleteItem) { return !incompleteItem.complete; });
            if (incompleteItemsUpdated.length !== incompleteItems.length) {
                updateIncompleteItems(incompleteItemsUpdated);
            }
        }
    }, [widgetDrills, prevWidgetDrills, incompleteItems]);
    var addIncompleteItem = react_1.useCallback(function (item) {
        updateIncompleteItems(addOrUpdateDrillConfigItem(incompleteItems, item));
    }, [incompleteItems]);
    var deleteIncompleteItem = react_1.useCallback(function (item) {
        var incompleteItemsUpdated = incompleteItems.filter(function (incompleteItem) { return incompleteItem.localIdentifier !== item.localIdentifier; });
        updateIncompleteItems(incompleteItemsUpdated);
    }, [incompleteItems]);
    var completeItem = react_1.useCallback(function (item) {
        var incompleteItemsUpdated = incompleteItems.map(function (incompleteItem) {
            if (incompleteItem.localIdentifier === item.localIdentifier) {
                return tslib_1.__assign(tslib_1.__assign({}, incompleteItem), { complete: true });
            }
            return incompleteItem;
        });
        updateIncompleteItems(incompleteItemsUpdated);
    }, [incompleteItems]);
    var onChangeItem = react_1.useCallback(function (changedItem) {
        var incompleteItem = tslib_1.__assign(tslib_1.__assign({}, changedItem), { complete: false });
        addIncompleteItem(incompleteItem);
    }, [addIncompleteItem]);
    var onOriginSelect = react_1.useCallback(function (selectedItem) {
        if (types_1.isAvailableDrillTargetMeasure(selectedItem)) {
            var incompleteMeasureItem = {
                type: "measure",
                localIdentifier: selectedItem.measure.measureHeaderItem.localIdentifier,
                title: selectedItem.measure.measureHeaderItem.name,
                attributes: selectedItem.attributes,
                drillTargetType: undefined,
                complete: false,
            };
            addIncompleteItem(incompleteMeasureItem);
        }
        else {
            var incompleteAttributeItem = {
                type: "attribute",
                localIdentifier: selectedItem.attribute.attributeHeader.localIdentifier,
                title: selectedItem.attribute.attributeHeader.formOf.name,
                attributes: selectedItem.intersectionAttributes,
                drillTargetType: undefined,
                complete: false,
            };
            addIncompleteItem(incompleteAttributeItem);
        }
    }, [addIncompleteItem]);
    var isItemNew = react_1.useCallback(function (changedItem) {
        // interaction is new if it has an incomplete item associated with it
        return incompleteItems.some(function (incompleteItem) {
            return incompleteItem.localIdentifier === changedItem.localIdentifier &&
                !incompleteItem.complete;
        });
    }, [incompleteItems]);
    return {
        incompleteItems: incompleteItems,
        isItemNew: isItemNew,
        completeItem: completeItem,
        deleteIncompleteItem: deleteIncompleteItem,
        onChangeItem: onChangeItem,
        onOriginSelect: onOriginSelect,
    };
};
//# sourceMappingURL=useDrillConfigIncompleteItems.js.map